import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { planEnrollmentService } from "./service";

type IPlanEnrollment = planEnrollmentApiSpec.PlanEnrollment;
type IPlanEnrollmentListQuery =
  planEnrollmentApiSpec.operations["listPlanEnrollments"]["parameters"]["query"];

export const getPlanEnrollments = async (
  query?: IPlanEnrollmentListQuery
): Promise<IPlanEnrollment[]> => {
  const { data } = await planEnrollmentService.get(``, {
    params: query
  });

  return data;
};
